import { render, staticRenderFns } from "./ContactLensImageTypeSwitcherFloat.vue?vue&type=template&id=4656f6d3&scoped=true&"
import script from "./ContactLensImageTypeSwitcherFloat.vue?vue&type=script&lang=ts&"
export * from "./ContactLensImageTypeSwitcherFloat.vue?vue&type=script&lang=ts&"
import style0 from "./ContactLensImageTypeSwitcherFloat.vue?vue&type=style&index=0&id=4656f6d3&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4656f6d3",
  null
  
)

export default component.exports